import { InputHTMLElement } from "components/input/baseHTMLElementInput";
import { Tooltip } from "components/components/tooltip/tooltip";
import template from "./textAreaElement.hbs";

export class TextAreaElement extends InputHTMLElement {

    private maxlength: number = null;
    private wordCounter: HTMLDivElement;

    constructor() {
        super();

        const maxlength = this.getAttribute("maxlength");
        if (this.isNumeric(maxlength)) {
            this.maxlength = parseInt(maxlength, 10);
        }

        const optTemplate = {
            "prefixId": "ta",
            "id": this.getAttribute("_id"),
            "className": "c-textarea-input__input o-form-component__input o-form-component__input-group__input",
            "disableFocusKeyboard": (this.getAttribute("disableFocusKeyboard") === 'true'),
            "maxlength": this.getAttribute("maxlength"),
            "rows": this.getAttribute("rows"),
            "cols": this.getAttribute("cols"),
            "style": this.getAttribute("_style")
        } as any;

        this.innerHTML = template(optTemplate);

        this.input = this.querySelector("textarea");
        this.wordCounter = this.querySelector(".c-textarea-input__wordCounter") as HTMLDivElement;

        this.bindEvents();
        Tooltip.bindElement(this);
    }

    private bindEvents(): void {

        this.genericBindEvents();

        //this.addEventFocusin_selectContent();

        this.input.addEventListener("focus", (evt) => {
            this.input.setSelectionRange(0, 0);
            if (!this.input.readOnly) {
                this.showCounter();
            }
            evt.stopPropagation();
        });

        this.input.addEventListener("focusout", (evt) => {
            this.hideCounter();
            evt.stopPropagation();
        });

        this.input.addEventListener("input", () => {
            this.showCounter();
            if (this.maxlength === this.getCurrentLength()) {
                this.input.classList.add("maxlengthReached");
            } else {
                this.input.classList.remove("maxlengthReached");
            }
        });
    }

    public set data(v: string) {
        this.input.value = v?.toString() ?? null;
        this.initialValue.value = this.data;
    }

    public get data(): string {
        let v = this.input.value;
        if (v === "") {
            return null;
        } else {
            return v;
        }
    }

    private showCounter() {
        this.wordCounter.innerHTML = this.maxlength - this.getCurrentLength() + " / " + this.maxlength;
        this.wordCounter.style.display = "block";
    }

    private hideCounter() {
        this.wordCounter.style.display = "none";
    }

    private getCurrentLength() {
        return this.input.value.length;
    }

}

export function initTextAreaWebComponent() {
    window.customElements.define("s6-text-area", TextAreaElement);
}
